// extracted by mini-css-extract-plugin
export default {"tableRow":"subzone_tableRow__g9TRs","tableCell":"subzone_tableCell__yzyov"};